import { attr, Model, fk, ModelType } from 'redux-orm';
import { getUnregisteredAttendees } from 'utils/interactions/attendees';
import { AttendeeInteraction } from 'utils/interactions/types';
import { IInteraction } from 'models/Interaction';
import Company from 'models/Company';

import Contact from 'models/Contact';
import {
  GET_COMPANY_PLANNED_INTERACTIONS_SUCCESS,
  ARCHIVE_REMINDER_SUCCESS,
} from 'actions';

class PlannedInteraction extends Model<
  typeof PlannedInteraction,
  IInteraction
> {
  contactId!: Contact;

  companyId!: Company;

  attendingContacts!: Array<unknown>;

  attendingUsers!: Array<{
    id: string;
    emails: string[];
    phone: string[];
    firstName: string;
    lastName: string;
  }>;

  static reducer(action: any, model: ModelType<PlannedInteraction>) {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case GET_COMPANY_PLANNED_INTERACTIONS_SUCCESS:
        action.data.map((d: IInteraction) =>
          model.upsert({
            ...d,
            id: d.sourceId,
          }),
        );
        break;

      case ARCHIVE_REMINDER_SUCCESS: {
        const current = model.withId(action.id);
        if (current) {
          current.delete();
        }
        break;
      }
    }

    return undefined;
  }

  toViewModel() {
    return {
      ...this.ref,
      company: this.companyId ? this.companyId.toViewModel() : null,
      contact: this.contactId ? this.contactId.toViewModel() : null,
      attendingUsers: this.attendingUsers || [],
      attendingContacts: this.attendingContacts || [],
      /*
        ref type does not allow property access on even though it's a plain object.
        TODO - refactor away from toViewModel and ref usage.
      */
      otherAttendees: getUnregisteredAttendees(
        this.ref as unknown as AttendeeInteraction,
      ),
    };
  }
}

PlannedInteraction.modelName = 'PlannedInteraction';

PlannedInteraction.fields = {
  id: attr(),
  contactId: fk('Contact'),
  companyId: fk('Company'),
  attendingUsers: attr(),
  attendingContacts: attr(),
  due: attr(),
  interactionType: attr(),
  sourceEvent: attr(),
  sourceId: attr(),
  title: attr(),
};

export type PlannedInteractionViewModel = ReturnType<
  PlannedInteraction['toViewModel']
>;

export default PlannedInteraction;
